import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  invoice_flow__multi_time_remainin: 'Time remaining',
  invoice_flow__multi_or: 'OR',
  invoice_flow__multi_copy_code: 'Copy code',
  invoice_flow__multi_open_app: 'Open in App',
  invoice_flow__multi_return_button: 'Return to web-site',
  invoice_flow__card_transfer_button: 'Confirm',

  //Steps
  invoice_flow__multi_rapipago_step_1:
    'To pay online, copy the generated code on the payment form and make the payment in the payment app.',
  invoice_flow__multi_rapipago_step_2:
    'To pay offline, save the generated barcode (voucher) or print it out and go to a Rapipago office or partner stores to pay.',
  invoice_flow__multi_upi_qr_step_1: 'Scan or copy QR code above',
  invoice_flow__multi_upi_qr_step_2: 'Make a payment',
  invoice_flow__multi_step_3:
    'Confirm the payment by providing <b>{attributes}</b> and press "Confirm" button',
  invoice_flow__multi_upi_qr_mob_step_1: 'Scan QR code above or use "Open in app" button',

  invoice_flow__multi_bank_transfer_step_1: 'Copy the requisites',
  invoice_flow__multi_bank_transfer_step_2: 'Make a payment',

  invoice_flow__card_transfer_step_1: 'Copy requisites',
  invoice_flow__card_transfer_step_2:
    'Transfer specified amount (use your bank account or visit the nearest bank or self-service terminal)',
  invoice_flow__card_transfer_step_3: 'Fill confirmation data: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4:
    'After successful completion of the transfer - click <b>"Confirm"</b>',
};
